/* eslint-disable import/prefer-default-export */
export const linesOfTextToArray = (text: string): string[] | '' => (text && text.length ? text.split('\n') : '');
/* eslint-enable import/prefer-default-export */
